import React from 'react';
import PropTypes from 'prop-types';

const ConditionalWrapperDivs = ( props ) => {
  const {
    condition,
    classNamesArray,
    children,
  } = props;

  // Reverse Names so they get wrapped in the order you would expect.
  const reversedClassNames = classNamesArray?.reverse();

  let wrappedContent = children;
  if ( children && condition && classNamesArray.length > 0 ) {
    reversedClassNames?.forEach( ( className ) => {
      wrappedContent = (
        <div className={className}>
          { wrappedContent }
        </div>
      );
    } );
  }

  return wrappedContent;
};

ConditionalWrapperDivs.propTypes = {
  condition: PropTypes.bool,
  classNamesArray: PropTypes.arrayOf( PropTypes.string ),
  children: PropTypes.node,
};

ConditionalWrapperDivs.defaultProps = {
  condition: false,
  classNamesArray: [],
  children: null,
};

export default ConditionalWrapperDivs;
